import { createSelector } from 'reselect'

import { ImmutableTypedMap } from '@lyrahealth-inc/shared-app-logic/src/features/common/types/Immutable'
import { ProviderObject } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'

export const getT1State = (state: Map<string, any>) => state?.get('t1Flow')

export const getT1OnsiteProviders = createSelector(getT1State, (t1State) => t1State?.get('t1') || [])

export const getT1OnsiteProvidersAddresses = createSelector(getT1OnsiteProviders, (providers) =>
  providers?.map((provider: ImmutableTypedMap<ProviderObject>) => provider.get('address')),
)

export const getLoadingOnsiteProviders = createSelector(getT1State, (t1State) =>
  t1State?.get('loadingOnsiteProviders', false),
)

export const getIsOnsiteEligible = createSelector(getT1State, (t1State) => t1State?.get('isOnsiteEligible'))
